const Categories = {
  STANDARD: 'standard',
  LOYALTY: 'loyalty',
  PACKAGE: 'package'
}

export default Categories
